export default __webpack_public_path__ + "bf213704dce6b437ede470c606b849a2.woff2";